const PK10 = (Vue) => {
  const data = Vue.dataSource;
  const ballarr = data.lastResult.split(',')
  const sum = Number(ballarr[0]) + Number(ballarr[1]);
  // 0:双，大，龙  1：单,小虎
  return {
    preDrawCode: ballarr,
    drawIssue: data.resultIssueId,
    drawCount: data.issueSeq,
    sumBigSamll: 0,
    countTime: Vue.second,
    sumSingleDouble: 0,
    lotName: "北京PK10",
    sumFS: Number(ballarr[0]) + Number(ballarr[1]),
    sumBigSamll: sum > 11 ? 0 : 1,
    sumSingleDouble: sum % 2 == 0 ? 1 : 0,
    firstDT: (ballarr[0] > ballarr[9]) ? 0 : 1,
    secondDT: (ballarr[1] > ballarr[8]) ? 0 : 1,
    thirdDT: (ballarr[2] > ballarr[7]) ? 0 : 1,
    fourthDT: (ballarr[3] > ballarr[6]) ? 0 : 1,
    fifthDT: (ballarr[4] > ballarr[5]) ? 0 : 1,
  }
}
const hpten = (Vue) => {
  const data = Vue.dataSource;
  const ballarr = data.lastResult.split(',')
  return {
    preDrawCode: ballarr,
    countTime: Vue.second,
    drawTime: data.closeTime,
    drawIssue: data.issueID,
    preDrawIssue: data.resultIssueId,
    drawCount: data.issueSeq,
    lotName: "广东快乐十分"
  }
}
const xyrb = (Vue) => {
  const data = Vue.dataSource;
  const ballarr = data.lastResult.split(',');
  return {
    "preDrawTime": data.openTime,
    "countTime": Vue.second,
    "preDrawIssue": data.resultIssueId,
    "preDrawCode": ballarr,
    "drawIssue": data.issueID,
    "drawTime": data.closeTime,
    "lotName": "pc蛋蛋幸运28",
  }
}
const nn = (Vue) => {
  const data = Vue.dataSource;
  const ballarr = data.lastResult.split(',');
  const sum = Number(ballarr[0]) + Number(ballarr[1])
  //0单大龙 1：小双虎
  return {
    "preDrawCode": ballarr,
    "countTime": Vue.second,
    "drawIssue": data.issueID,
    "drawTime": data.closeTime,
    "preDrawIssue": data.resultIssueId,
    "preDrawTime": data.openTime,
    "drawCount": data.issueSeq,
    "firstDT": ballarr[0] > ballarr[9] ? 0 : 1,
    "secondDT": ballarr[1] > ballarr[8] ? 0 : 1,
    "thirdDT": ballarr[2] > ballarr[7] ? 0 : 1,
    "fifthDT": ballarr[3] > ballarr[6] ? 0 : 1,
    "fourthDT": ballarr[4] > ballarr[5] ? 0 : 1,
    "sumBigSamll": sum > 13 ? 1 : 0,
    "sumFS": sum,
    "sumSingleDouble": sum % 2 == 0 ? 0 : 1,
    "lotName": "幸运飞艇",
  }
}
const ssc = (Vue) => {
  const data = Vue.dataSource;
  const ballarr = data.lastResult.split(',');
  const sum = ballarr.reduce((ac, cu) => {
    return Number(ac) + Number(cu)
  })
  return {
    preDrawCode: ballarr,
    countTime: Vue.second,
    preDrawIssue: data.resultIssueId,
    drawTime: data.closeTime,
    sumNum: sum,
    sumSingleDouble: sum % 2 == 0 ? 1 : 0,
    sumBigSmall: sum > 22 ? 0 : 1,
    dragonTiger: Number(ballarr[0]) > Number(ballarr[4]) ? 0 : 1
  }
}
const choose5 = (Vue) => {
  const data = Vue.dataSource;
  const ballarr = data.lastResult.split(',');
  const sum = ballarr.reduce((ac, cu) => {
    return Number(ac) + Number(cu)
  })
  //0单大龙 1：小双虎
  return {
    preDrawCode: ballarr,
    countTime: Vue.second,
    drawIssue: data.issueID,
    drawTime: data.closeTime,
    preDrawTime: data.openTime,
    drawCount: data.issueSeq,
    preDrawIssue: data.resultIssueId,
    sumNum: sum,
    sumSingleDouble: sum % 2 == 0 ? 1 : 0,
    sumBigSmall: sum > 30 ? 0 : 1,
    dragonTiger: ballarr[0] > ballarr[4] ? 0 : 1,
  }
}
const ks = (Vue) => {
  const data = Vue.dataSource;
  const ballarr = data.lastResult.split(',');
  const sum = ballarr.reduce((ac, cu) => {
    return Number(ac) + Number(cu)
  })
  //0单大龙 1：小双虎
  return {
    preDrawCode: ballarr,
    countTime: Vue.second,
    drawIssue: data.issueID,
    drawTime: data.closeTime,
    preDrawTime: data.openTime,
    drawCount: data.issueSeq,
    preDrawIssue: data.resultIssueId,
    sumNum: sum,
    sumSingleDouble: sum % 2 == 0 ? 1 : 0,
    sumBigSmall: sum > 10 ? 0 : 1,
  }
}
export default {
  PK10, hpten, xyrb, nn, ssc, choose5, ks
}


// WEBPACK FOOTER //
// ./src/pages/Trend/helpers/generateData.js